// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Configurations_navbar__UXro8","active":"Configurations_active__3E86e"};